
var data;
var country;
var myHeaders = new Headers();
myHeaders.append("Authorization", "Bearer 0ca5fe2254ae34");
var requestOptions = {
  method: "GET",
  headers: myHeaders,
  redirect: "follow",
};
fetch("https://ipinfo.io", requestOptions)
  .then((response) => response.json())
  .then((data) => {
    obj = data;
  })
  .then((data) => {
    country = obj["country"];
  })
  .then(() => {
    sessionStorage.setItem("country_ip", country);
  })
  .catch((error) => console.log("error", error));




